<template>
  <div class="product-bubble-wrapper">
    <div v-show="showBubble" class="product-bubble thead-bubble fnsku-kbn-thead-bubble" @mouseover="handleMouseOver()" @mouseleave="handleMouseLeave()" v-html="bubbleText" />
    <div>
      商品ラベル
      <i class="fa fa-question-circle thead-bubble-icon"
        @mouseover="handleMouseOver()"
        @mouseleave="handleMouseLeave()"
      />
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      showBubble: false
    }
  },
  computed: {
    bubbleText () {
      return `商品ラベルとしてFNSKUバーコードシール（FBAラベル）を利用することが可能です。<br/> &#60;FNSKUを利用する場合&#62; <br/> 商品ラベルとしてFNSKUバーコードシール（FBAラベル）を利用してください。<br/> &#60;FNSKUを利用しない場合&#62; <br/> 商品ラベルとしてセルモン倉庫専用バーコードシールを利用してください。`
    }
  },
  methods: {
    handleMouseOver () {
      this.showBubble = true
    },
    handleMouseLeave () {
      this.showBubble = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/deliveryRequests/components/FnskuKbnThead.vue